/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 活动已报名列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  activityRequest: cms.ApplyActivityRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.Page<cms.ApplyActivityListDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cms/apply-activities/registered`,
    data: activityRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
